import React from 'react';

import cn from 'classnames';
import { FormattedMessage } from 'react-intl';

import IconFemtasy from 'components/IconFemtasy';
import Typography from 'components/Typography';

import { JourneyFragment } from 'graphql/generated/graphql';

import { isJourneyCompleted, isJourneyInProgress } from 'helpers/series';

import './style.scss';

interface IProps {
  journey: JourneyFragment;
}

const progressLabelText = (journey: JourneyFragment) => {
  if (isJourneyInProgress(journey)) {
    return <FormattedMessage id="components.JourneyTile.status.inProgress" />;
  } else if (isJourneyCompleted(journey)) {
    return <FormattedMessage id="components.JourneyTile.status.completed" />;
  } else {
    return (
      <FormattedMessage
        id="components.JourneyTile.status.notStarted"
        values={{ count: journey.stories.totalCount }}
      />
    );
  }
};

const SeriesTag = ({ journey }: IProps) => {
  return (
    <Typography
      variant="small-thin"
      className={cn(
        'SeriesTag',
        isJourneyCompleted(journey) && 'COMPLETED',
        isJourneyInProgress(journey) && 'IN_PROGRESS',
        journey.stories.totalCount,
      )}
    >
      <IconFemtasy icon="Seriesline" size="16" />
      <div className="SeriesTag_bar" />
      <div className="SeriesTag_text">{progressLabelText(journey)}</div>
    </Typography>
  );
};

export default SeriesTag;
